/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipe_Ingredients_ViewInputs */

const en_recipe_ingredients_view = /** @type {(inputs: Recipe_Ingredients_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show ingredients`)
};

const de_recipe_ingredients_view = /** @type {(inputs: Recipe_Ingredients_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zutaten anzeigen`)
};

/**
* | output |
* | --- |
* | "Show ingredients" |
*
* @param {Recipe_Ingredients_ViewInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_ingredients_view = /** @type {((inputs?: Recipe_Ingredients_ViewInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_Ingredients_ViewInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_ingredients_view(inputs)
	return en_recipe_ingredients_view(inputs)
});